<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled" multiple
           [placeholder]="'Technische Einrichtung auswählen'">
  <nb-option *ngFor="let facilityElement of facilityElements"
             [value]="facilityElement">
    {{facilityElement | facilityElementTranslation}}
  </nb-option>
</nb-select>
